import { useLocation } from "wouter";

/**
 * Returns a handler that scrolls to a landing-page section by id.
 * If called from another route (e.g. /privacy), it navigates home first,
 * then scrolls to the section once the landing page has mounted.
 */
export function useSectionNav() {
  const [location, setLocation] = useLocation();

  return (id: string) => {
    const scroll = () =>
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

    if (location === "/") {
      scroll();
    } else {
      setLocation("/");
      window.setTimeout(scroll, 150);
    }
  };
}
